import React from "react";

// Components
import {
  ContactUsForm,
  GoogleReviews,
  HomeAbout,
  HomeOverLay,
  HomeServicesOffered,
  SEO,
} from "../Components";

export const Home = () => {
  return (
    <>
      <SEO
        title="Indianapolis Premier In-Home Dog Training"
        description="Professional in-home dog training in Indianapolis, Carmel, Noblesville, Fishers, Westfield & Zionsville. Private lessons, day training, board & train, and trained puppies."
        path="/"
      />
      <HomeOverLay />
      <HomeAbout />
      <HomeServicesOffered />
      <GoogleReviews />
      <ContactUsForm />
    </>
  );
};
